
import { defineComponent, ref, computed } from 'vue';
import { ComponentName } from '@/products/api/configuration/components/ComponentName';
import { DataType } from '@/products/api/configuration/application/DataType';
import { setupComponent } from '@/products/composables/setupComponent';
import { ProductItem } from '@/common/services/swagger/index.defs';

import InjectStyles from '@/common/components/InjectStyles.vue';
import Clickable from '@/common/components/Clickable.vue';
import VRuntimeTemplate from 'vue3-runtime-template';
import { DetailsCommand } from '@/products/api/runtime/CommandExecutor';
import { IDetailsVariantsTableOptions } from '@/products/api/configuration/components/IDetailsVariantsTableOptions';
import { attrValue } from '@/common/helpers/productAttributes';

export default defineComponent({
  name: ComponentName.detailsVariantsTable,

  components: {
    InjectStyles,
    Clickable,
    VRuntimeTemplate,
  },

  props: {
    instanceId: String,
  },

  setup(props) {
    const root = ref<HTMLElement>();

    const { componentName, isReady, isWebComponent, instance, store, t, routeData } =
      setupComponent(root, props.instanceId, [DataType.ProductVariantsTable]);

    const componentOptions = computed(
      () =>
        store.value?.options.components?.detailsVariantsTable ??
        ({} as IDetailsVariantsTableOptions),
    );

    const groups = computed(() => {
      if (!store.value?.data.productVariantsTable?.items?.length) return [];

      return store.value?.data.productVariantsTable.items;
    });

    const visible = computed(() => {
      return componentOptions.value.visible !== false && (groups.value?.length ?? 0) > 0;
    });

    const details = async (productItem: ProductItem) => {
      if (productItem?.inactive) return;

      if (routeData.value && productItem) {
        try {
          await instance.value?.execute(new DetailsCommand(productItem));
        } catch (error) {
          // Ignore Error
        }
      }
    };

    return {
      root,
      componentName,
      isReady,
      isWebComponent,
      instance,
      store,
      t,
      componentOptions,
      groups,
      visible,
      attrValue,
      Clickable,
      details,
    };
  },
});
